// extracted by mini-css-extract-plugin
module.exports = {"wrap":"lk","heading":"mk"};